$(document).ready(function () {
    (function () {
        let ajaxLockActive = false;
        const ajaxPathProductLabel = '/action/product-label';
        const ajaxPathProductLabelActivate = '/activate';
        const ajaxPathProductLabelDeactivate = '/deactivate';
        const productLabelElementPrimaryStateClasses = 'bg-primary border-primary hover:bg-primary/90 hover:border-primary/90';
        const productLabelElementDangerStateClasses = 'bg-danger border-danger hover:bg-danger/90 hover:border-danger/90';
        const productLabelCanvasClasses = 'relative shadow-dark w-full overflow-hidden';
        const productLabelDraggableClasses = 'draggable bg-slate-100 absolute z-10 flex h-16 w-40 select-none border border-primary bg-sky-100 items-center justify-center';
        const productLabelDraggableActiveClasses = 'z-20 font-bold shadow-lg';
        const productLabelDraggableWidthClasses = 'draggable-width absolute left-0 right-0 top-0 text-center';
        const productLabelDraggableHeightClasses = 'draggable-height absolute bottom-0 right-0 top-0 text-center writing-vertical-lr';
        const productLabelDraggableNameClasses = 'draggable-name relative z-10 px-4 text-center text-sm text-black';
        const productLabelDraggablePositionResetClasses = 'items-start items-center items-end justify-start justify-center justify-end';
        const productLabelDraggableWidthPositionResetClasses = 'top-0 top-1/2';
        const productLabelDraggableHeightPositionResetClasses = 'bottom-0 top-0';
        const productLabelDraggablePositionClasses = {
            top_left: {
                draggable: 'items-start justify-start',
                width: 'top-1/2',
                height: 'bottom-0 top-0'
            },
            top_center: {
                draggable: 'items-start justify-center',
                width: 'top-1/2',
                height: 'bottom-0 top-0'
            },
            top_right: {
                draggable: 'items-start justify-end',
                width: 'top-1/2',
                height: 'bottom-0 top-0'
            },
            middle_left: {
                draggable: 'items-center justify-start',
                width: 'top-0',
                height: 'bottom-0 top-0'
            },
            center: {
                draggable: 'items-center justify-center',
                width: 'top-0',
                height: 'bottom-0 top-0'
            },
            middle_right: {
                draggable: 'items-center justify-end',
                width: 'top-0',
                height: 'top-0 pt-1'
            },
            bottom_left: {
                draggable: 'items-end justify-start',
                width: 'top-0',
                height: 'bottom-0 top-0'
            },
            bottom_center: {
                draggable: 'items-end justify-center',
                width: 'top-0',
                height: 'bottom-0 top-0'
            },
            bottom_right: {
                draggable: 'items-end justify-end',
                width: 'top-0',
                height: 'bottom-0 top-0'
            }
        };
        let currentProductLabelId = parseInt($('#product_label_form_wrapper #product_label_id', document).val(), 10) || 0;
        let productLabelFormDirty = false;

        let scale = 1;

        const draggableElementWidth = 150;
        const draggableElementHeight = 34;

        function getCanvasScale(labelWidth, canvasWidth) {
            return Number(labelWidth) / Number(canvasWidth);
        }

        function getCanvasPixels(value, storedScale, currentScale) {
            return Number(value) * storedScale / currentScale;
        }

        function getLabelMillimeters(value, currentScale) {
            return Number(Number(value) * currentScale);
        }

        function getStoredMeasurement(value, currentScale) {
            return Number(getLabelMillimeters(value, currentScale).toFixed(4));
        }

        function getFormattedMillimeters(value, currentScale) {
            return getLabelMillimeters(value, currentScale).toFixed(1);
        }

        initColorPickers();
        initTooltip();
        setActiveProductLabelListItem();
        markProductLabelFormClean();

        $(document).on('click', '#product_label_type_tabs .product_label_type_tab', function () {
            if (ajaxLockActive) {
                return false;
            }

            const selectedType = $(this).attr('data-type');
            const currentType = getCurrentLabelType();

            if (!selectedType || selectedType === currentType) {
                return false;
            }

            if (!confirmResetIfNeeded()) {
                return false;
            }

            switchLabelType(selectedType);
            return false;
        });

        $(document).on('click', '#product_label_new_label_btn', function () {
            if (ajaxLockActive) {
                return false;
            }

            if (!confirmResetIfNeeded()) {
                return false;
            }

            const currentType = getCurrentLabelType();
            switchLabelType(currentType);
            return false;
        });

        $(document).on('click', '#product_label_form_wrapper .product_label_element', function () {
            if (!$('#product_label_form_wrapper #product_label_canvas', document).length) {
                return;
            }

            const element = $(this);
            const onCanvas = element.attr('data-on-canvas');
            const elementName = element.attr('data-name');
            const canvas = $('#product_label_form_wrapper #product_label_canvas', document);

            if (onCanvas == '0') {
                element.attr('data-on-canvas', '1');
                element.attr('title', 'Remove from canvas');
                setProductLabelElementButtonState(element, 'danger');

                // toggle element settings
                $('.product_label_element_settings', document).hide();
                $(`.product_label_element_settings[data-name=${elementName}]`, document).show();

                // disable all draggable elements
                setDraggableActiveState(canvas.find('.draggable'), false);

                // show or append new draggable active element on canvas
                const draggableElement = canvas.find(`.draggable[data-name='${elementName}']`, document);
                if (draggableElement.length > 0) {
                    draggableElement.show();
                    setDraggableActiveState(draggableElement, true);
                } else {
                    const newDraggableElement = $(`<div class="${productLabelDraggableClasses} active" data-name='${elementName}'>
                                                    <div class="${productLabelDraggableWidthClasses}">${Number(draggableElementWidth * scale).toFixed(1)} mm</div>
                                                    <div class="${productLabelDraggableHeightClasses}">${Number(draggableElementHeight * scale).toFixed(1)} mm</div>
                                                    <div class="${productLabelDraggableNameClasses}">${element.text().trim()}</div>
                                                    </div>`);
                    canvas.append(newDraggableElement);
                    setDraggableActiveState(newDraggableElement, true);
                    initDraggable(newDraggableElement[0]);
                }
            }

            if (onCanvas == '1') {
                element.attr('data-on-canvas', '0');
                element.attr('title', 'Add to canvas');
                setProductLabelElementButtonState(element, 'primary');
                const draggableElement = canvas.find(`.draggable[data-name='${elementName}']`);
                draggableElement.hide();
                setDraggableActiveState(draggableElement, false);

                // activate sibling visible draggable element if canvas doesn't have active draggable element
                if (!canvas.find(`.draggable.active`).length) {
                    const draggableElementSibling = draggableElement.siblings('.draggable:visible').first();
                    if (draggableElementSibling.length) {
                        $('.product_label_element_settings', document).hide();
                        setDraggableActiveState(draggableElementSibling, true);
                        const draggableElementSiblingName = draggableElementSibling.attr('data-name');
                        $(`.product_label_element_settings[data-name=${draggableElementSiblingName}]`, document).show();
                    }
                }
            }

            markProductLabelFormDirty();
            return false;
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_generate_canvas_btn', function () {
            const width = $('#product_label_form_wrapper #product_label_width', document).val();
            const height = $('#product_label_form_wrapper #product_label_height', document).val();

            if (!width || !height || isNaN(width) || isNaN(height) || width <= 0 || height <= 0) {
                alert('Please enter correct width and height');
                return;
            }

            const canvasWrapper = $('#product_label_form_wrapper #product_label_canvas_wrapper', document);
            const productLabelId = $('#product_label_form_wrapper #product_label_id', document).val();

            const aspectRatio = width / height;
            const canvasWidth = canvasWrapper[0].getBoundingClientRect().width;
            const canvasHeight = canvasWidth / aspectRatio;

            scale = getCanvasScale(width, canvasWidth);

            let canvas;
            if (productLabelId > 0) {
                canvas = $('#product_label_form_wrapper #product_label_canvas', document);
            } else {
                const productLabelElements = $('#product_label_elements_list .product_label_element', document)
                    .attr('data-on-canvas', '0')
                    .attr('title', 'Add to canvas')
                    .prop('disabled', false)
                    .removeAttr('disabled')
                    .removeClass('disabled');
                productLabelElements.each(function () {
                    setProductLabelElementButtonState(this, 'primary');
                });
                canvas = $(`<div id='product_label_canvas' class="${productLabelCanvasClasses}"></div>`);
                canvasWrapper.html(canvas);
            }

            canvas.css({
                'width': `100%`,
                'height': `${Number(canvasHeight).toFixed(2)}px`
            });

            // set real size of draggable elements
            if (canvas.find('.draggable').length) {
                canvas.find('.draggable').each(function (_, draggableElement) {
                    const elementWidth = $(draggableElement)[0].getBoundingClientRect().width;
                    const elementHeight = $(draggableElement)[0].getBoundingClientRect().height;

                    $(draggableElement).find('.draggable-width').text(`${getFormattedMillimeters(elementWidth, scale)} mm`);
                    $(draggableElement).find('.draggable-height').text(`${getFormattedMillimeters(elementHeight, scale)} mm`);
                });
            }

            $('#product_label_form_wrapper #product_label_buttons', document).show();
            markProductLabelFormDirty();

            return false;
        });

        $(document).on('click', '#product_label_list .list-group-item', function () {
            if (ajaxLockActive) {
                return false;
            }

            const productLabelId = $(this).attr('product_label_id');

            if (productLabelId <= 0) {
                return false;
            }

            ajaxLockActive = true;
            showTailwindPreloader();

            getProductLabelForm(productLabelId);
            return false;
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_save_btn', function () {
            if (ajaxLockActive) {
                return false;
            }

            if (!validateForm()) {
                return false;
            }

            const draggableElements = $('#product_label_canvas .draggable:visible', document);

            const canvas = $('#product_label_form_wrapper #product_label_canvas', document);
            const productLabelId = $('#product_label_form_wrapper #product_label_id', document).val();
            const name = $('#product_label_form_wrapper #product_label_name', document).val();
            const labelType = getCurrentLabelType();
            const width = $('#product_label_form_wrapper #product_label_width', document).val();
            const height = $('#product_label_form_wrapper #product_label_height', document).val();
            const canvasWidth = canvas[0].getBoundingClientRect().width;
            const currentScale = getCanvasScale(width, canvasWidth);

            const data = {
                name: name,
                type: labelType
            };
            const params = {
                width: Number(width),
                height: Number(height),
                scale: 1,
                elements: {}
            };
            draggableElements.each(function (_, draggableElement) {
                const elementName = $(draggableElement).attr('data-name');
                const elementX = $(draggableElement).attr('data-x') ? parseFloat($(draggableElement).attr('data-x')) : 0;
                const elementY = $(draggableElement).attr('data-y') ? parseFloat($(draggableElement).attr('data-y')) : 0;
                const elementWidth = $(draggableElement)[0].getBoundingClientRect().width;
                const elementHeight = $(draggableElement)[0].getBoundingClientRect().height;

                params.elements[elementName] = {
                    x: getStoredMeasurement(elementX, currentScale),
                    y: getStoredMeasurement(elementY, currentScale),
                    width: getStoredMeasurement(elementWidth, currentScale),
                    height: getStoredMeasurement(elementHeight, currentScale)
                }

                // Set font size
                if ($(`#product_label_element_settings_list input[name='${elementName}_font_size']`, document).length) {
                    params.elements[elementName].font_size = Number($(`#product_label_element_settings_list input[name='${elementName}_font_size']`, document).val());
                }

                // Set font color
                if ($(`#product_label_element_settings_list button[name='${elementName}_font_color']`, document).length) {
                    params.elements[elementName].font_color = $(`#product_label_element_settings_list button[name='${elementName}_font_color']`, document).css('background-color');
                }

                // Set text position
                if ($(`#product_label_element_settings_list select[name='${elementName}_text_position']`, document).length) {
                    params.elements[elementName].text_position = $(`#product_label_element_settings_list select[name='${elementName}_text_position']`, document).val();
                }

                // Set barcode image position
                if ($(`#product_label_element_settings_list select[name='${elementName}_image_position']`, document).length) {
                    params.elements[elementName].image_position = $(`#product_label_element_settings_list select[name='${elementName}_image_position']`, document).val();
                }
            });

            data.params = JSON.stringify(params);

            ajaxLockActive = true;
            showTailwindPreloader();

            if (productLabelId == 0) {
                createProductLabel(data);
            }

            if (productLabelId > 0) {
                updateProductLabel(productLabelId, data);
            }

            return false;
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_canvas .draggable', function () {
            const draggableElement = $(this);
            setDraggableActiveState(draggableElement.siblings(), false);
            setDraggableActiveState(draggableElement, true);
            const name = draggableElement.attr('data-name');

            $(`.product_label_element_settings`, document).hide();
            $(`.product_label_element_settings[data-name='${name}']`, document).show();

            return false;
        });

        $(document).on('change', '#product_label_form_wrapper .product_label_element_text_position', function () {
            const elementName = $(this).parents('.product_label_element_settings').attr('data-name');
            const value = $(this).val();

            applyDraggablePosition($(`#product_label_canvas .draggable[data-name=${elementName}]`, document), value);
            markProductLabelFormDirty();

            return false;
        });

        $(document).on('input change', '#product_label_form_wrapper #product_label_name, #product_label_form_wrapper #product_label_width, #product_label_form_wrapper #product_label_height, #product_label_element_settings_list .product_label_element_font_size, #product_label_element_settings_list .product_label_element_text_position', function () {
            markProductLabelFormDirty();
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_activate_btn', function () {
            if (ajaxLockActive) {
                return false;
            }

            const productLabelId = $('#product_label_form_wrapper #product_label_id', document).val();
            if (productLabelId <= 0) {
                return false;
            }

            ajaxLockActive = true;
            showTailwindPreloader();

            activateProductLabel(productLabelId);
            return false;
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_deactivate_btn', function () {
            if (ajaxLockActive) {
                return false;
            }

            const productLabelId = $('#product_label_form_wrapper #product_label_id', document).val();
            if (productLabelId <= 0) {
                return false;
            }

            ajaxLockActive = true;
            showTailwindPreloader();

            deactivateProductLabel(productLabelId);
            return false;
        });

        $(document).on('change', '#product_label_list_wrapper input[name="display_deactivated"]', function(e){
            if (ajaxLockActive) {
                return false;
            }

            ajaxLockActive = true;
            showTailwindPreloader();

            refreshList();

            return false;
        });

        $(document).on('click', '#product_label_list_wrapper span#filter_span_wrapper', function () {
            $('div#filter_options_wrapper', document).toggle();

            const arrow = $('span#filter_span_wrapper span.glyphicon');
            if (arrow.hasClass('glyphicon-chevron-right')) {
                arrow.removeClass('glyphicon-chevron-right');
                arrow.addClass('glyphicon-chevron-down');
            } else {
                arrow.removeClass('glyphicon-chevron-down');
                arrow.addClass('glyphicon-chevron-right');
            }

            return false;
        });

        function validateForm() {
            let errorMessage = '';

            const name = $('#product_label_form_wrapper #product_label_name', document).val();
            const width = $('#product_label_form_wrapper #product_label_width', document).val();
            const height = $('#product_label_form_wrapper #product_label_height', document).val();

            if (name === '') {
                errorMessage += `<li>Etikettnavn er feil</li>`;
            }

            if (width === '' || isNaN(width) || width <= 0) {
                errorMessage += '<li>Bredde er feil</li>';
            }

            if (height === '' || isNaN(height) || height <= 0) {
                errorMessage += '<li>Høyde er feil</li>';
            }

            const draggableElements = $('#product_label_canvas .draggable:visible', document);

            if (!draggableElements.length) {
                errorMessage += '<li>Legg til minst ett etikettelement på lerretet</li>';
            }

            if (!checkOverlaps(draggableElements)) {
                errorMessage += '<li>Det er overlappende etikettelementer på lerretet. Vennligst juster plasseringen og størrelsen på elementene</li>';
            }

            draggableElements.each(function (_, draggableElement) {
                const elementName = $(draggableElement).attr('data-name');
                const fontSizeInput = $(`#product_label_element_settings_list input[name='${elementName}_font_size']`, document);
                const fontColorBtn = $(`#product_label_element_settings_list button[name='${elementName}_font_color']`, document);
                const textPositionSelect = $(`#product_label_element_settings_list select[name='${elementName}_text_position']`, document);
                const imagePositionSelect = $(`#product_label_element_settings_list select[name='${elementName}_image_position']`, document);

                const elementWidth = $(draggableElement)[0].getBoundingClientRect().width;
                const elementHeight = $(draggableElement)[0].getBoundingClientRect().height;

                if (elementWidth <= 0 || elementHeight <= 0) {
                    errorMessage += `<li>Størrelse for etikettelement "${elementName}" er feil</li>`;
                }

                if (fontSizeInput.length && !fontSizeInput.val()) {
                    errorMessage += `<li>Skriftstørrelse for etikettelement "${elementName}" er feil</li>`;
                }

                if (fontColorBtn.length && !fontColorBtn.css('background-color')) {
                    errorMessage += `<li>Skriftfarge for etikettelement "${elementName}" er feil</li>`;
                }

                if (textPositionSelect.length && !textPositionSelect.val()) {
                    errorMessage += `<li>Tekstposisjon for etikettelement "${elementName}" er feil</li>`;
                }

                if (imagePositionSelect.length && !imagePositionSelect.val()) {
                    errorMessage += `<li>Bildeposisjon for etikettelement "${elementName}" er feil</li>`;
                }
            });

            if (errorMessage) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', `<ul>${errorMessage}</ul>`, 'Lukk', 'error');
                return false;
            }

            return true;
        }

        function initColorPickers() {
            $('#product_label_element_settings_list .product_label_color_picker', document).each(function () {
                $(this).simpleColorPicker({
                    showEffect: 'fade',
                    hideEffect: 'slide',
                    onChangeColor: function (color) {
                        $(this).css("background", color);

                        const elementName = $(this).parents('.product_label_element_settings').attr('data-name');

                        $(`#product_label_canvas .draggable[data-name=${elementName}] .draggable-name`, document).css({
                            'color': `${color}`
                        });
                        markProductLabelFormDirty();
                    }
                });
            });
        }

        function activateProductLabel(productLabelId) {
            $.ajax({
                type: 'POST',
                url: ajaxPathProductLabel + '/' + productLabelId + ajaxPathProductLabelActivate,
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_wrapper', document).replaceWith(data.html);
                currentProductLabelId = getCurrentProductLabelId();
                setActiveProductLabelListItem();
                calculateCanvas(data.params);
                initDraggable('.draggable');
                initColorPickers();
                initTooltip();
                markProductLabelFormClean();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke aktivere etikett', 'Lukk', 'error');
            }).always(function () {
                ajaxLockActive = false;
                hideTailwindPreloader();
            });
        }

        function deactivateProductLabel(productLabelId) {
            $.ajax({
                type: 'POST',
                url: ajaxPathProductLabel + '/' + productLabelId + ajaxPathProductLabelDeactivate,
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_wrapper', document).replaceWith(data.html);
                currentProductLabelId = getCurrentProductLabelId();
                setActiveProductLabelListItem();
                calculateCanvas(data.params);
                initDraggable('.draggable');
                initColorPickers();
                initTooltip();
                markProductLabelFormClean();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke deaktivere etikett', 'Lukk', 'error');
            }).always(function () {
                ajaxLockActive = false;
                hideTailwindPreloader();
            });
        }

        function createProductLabel(data) {
            $.ajax({
                type: 'POST',
                url: ajaxPathProductLabel,
                data: data,
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_wrapper', document).replaceWith(data.html);
                currentProductLabelId = getCurrentProductLabelId();
                setActiveProductLabelListItem();
                calculateCanvas(data.params);
                initDraggable('.draggable');
                initColorPickers();
                initTooltip();
                markProductLabelFormClean();
                showProductLabelSaveSuccess();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke opprette etikett', 'Lukk', 'error');
            }).always(function () {
                ajaxLockActive = false;
                hideTailwindPreloader();
            });
        }

        function updateProductLabel(productLabelId, data) {
            $.ajax({
                type: 'POST',
                url: ajaxPathProductLabel  + '/' + productLabelId,
                data: data,
                dataType: 'json'
            }).success(function (data) {
                currentProductLabelId = getCurrentProductLabelId();
                markProductLabelFormClean();
                showProductLabelSaveSuccess();
                refreshList();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke oppdatere etikett', 'Lukk', 'error');
            }).always(function () {
                hideTailwindPreloader();
            });
            return false;
        }

        function getProductLabelForm(productLabelId) {
            $.ajax({
                type: 'GET',
                url: ajaxPathProductLabel + '/' + productLabelId,
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_form_wrapper').replaceWith(data.html);
                currentProductLabelId = productLabelId;
                setActiveProductLabelListItem();
                const newType = getCurrentLabelType();
                if (newType) {
                    updateListHeader(newType);
                }
                calculateCanvas(data.params);
                initDraggable('.draggable');
                initColorPickers();
                initTooltip();
                markProductLabelFormClean();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke hente etikett', 'Lukk', 'error');
            }).always(function(){
                ajaxLockActive = false;
                hideTailwindPreloader();
            });
        }

        function refreshList() {
            const displayDeactivated = $('#product_label_list_wrapper input[name="display_deactivated"]', document).is(':checked')?'1':'0';
            const labelType = getCurrentLabelType();

            $.ajax({
                type: 'GET',
                url: ajaxPathProductLabel,
                data: {
                    display_deactivated: displayDeactivated,
                    type: labelType
                },
                dataType: 'json',
            }).success(function (data) {
                $('#product_label_list', document).html(data.html);
                setActiveProductLabelListItem();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke å oppdatere listen', 'Lukk', 'error');
            }).always(function () {
                hideTailwindPreloader();
                ajaxLockActive = false;
            });
        }

        function calculateCanvas(params) {
            const width = params.width;
            const height = params.height;
            const elements = params.elements || {};

            if (!width || !height || isNaN(width) || isNaN(height) || width <= 0 || height <= 0) {
                return;
            }

            if (!Object.keys(elements).length) {
                return;
            }

            const canvas = $('#product_label_form_wrapper #product_label_canvas', document);

            const aspectRatio = width / height;
            const canvasWidth = canvas[0].getBoundingClientRect().width;
            const canvasHeight = canvasWidth / aspectRatio;
            const currentScale = getCanvasScale(width, canvasWidth);
            const storedScale = Number(params.scale) || 1;

            $('#product_label_form_wrapper #product_label_canvas .draggable', document).each(function (_, draggableElement) {
                const name = $(draggableElement).attr('data-name');
                if (!elements[name]) {
                    return;
                }

                const elementX = getCanvasPixels(elements[name].x, storedScale, currentScale);
                const elementY = getCanvasPixels(elements[name].y, storedScale, currentScale);
                const elementWidth = getCanvasPixels(elements[name].width, storedScale, currentScale);
                const elementHeight = getCanvasPixels(elements[name].height, storedScale, currentScale);

                // Set size and position of draggable element
                $(draggableElement).css({
                    'width': `${elementWidth}px`,
                    'height': `${elementHeight}px`,
                    'top': `${elementY}px`,
                    'left': `${elementX}px`
                });

                // Set text style of draggable element
                $(draggableElement).find('.draggable-name').css({
                    'font-size': `${elements[name].font_size}px`,
                    'color': `${elements[name].font_color}`
                });

                // Set text position of draggable element
                applyDraggablePosition(draggableElement, elements[name].text_position || 'center');

                $(draggableElement).attr('data-x', elementX);
                $(draggableElement).attr('data-y', elementY);

                // Set real size of draggable element
                $(draggableElement).find('.draggable-width').text(`${getFormattedMillimeters(elementWidth, currentScale)} mm`);
                $(draggableElement).find('.draggable-height').text(`${getFormattedMillimeters(elementHeight, currentScale)} mm`);
            });

            canvas.css({
                'height': `${Number(canvasHeight).toFixed(2)}px`
            });

            scale = currentScale;
        }

        $('#product_label_wrapper', document).on('input', 'input.input-integer', function(event) {
            const value = event.target.value;
            const sanitizedValue = value.replace(/[^0-9]/g, '');
            if (sanitizedValue !== value) {
                event.target.value = sanitizedValue;
            }
            return false;
        });


        $('#product_label_wrapper', document).on('input', '.product_label_element_font_size', function (event) {
            const elementName = $(this).parents('.product_label_element_settings').attr('data-name');
            $(`#product_label_canvas .draggable[data-name=${elementName}] .draggable-name`, document).css({
                'font-size': `${$(this).val()}px`
            });
            markProductLabelFormDirty();

            return false;
        });

        /**
         * @param {string|HTMLElement} target
         */
        function initDraggable(target) {
            if (typeof interact === 'undefined') {
                console.error('InteractJS is missing. Install dependencies and rebuild static assets.');
                return;
            }
            interact(target).draggable({
                // inertia: true,
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: 'parent',
                        // endOnly: true
                    })
                ],
                listeners: {
                    move(event) {
                        const $target = $(event.target);
                        let x = (parseFloat($target.attr('data-x')) || 0) + event.dx;
                        let y = (parseFloat($target.attr('data-y')) || 0) + event.dy;

                        $target.css({
                            'top': `${Number(y)}px`,
                            'left': `${Number(x)}px`
                        });

                        $target.attr('data-x', x);
                        $target.attr('data-y', y);
                        markProductLabelFormDirty();
                    }
                }
            })
                .resizable({
                    edges: {left: true, right: true, bottom: true, top: true},
                    modifiers: [
                        interact.modifiers.restrictSize({
                            min: {width: draggableElementWidth, height: draggableElementHeight},
                        }),
                        interact.modifiers.restrictEdges({
                            outer: 'parent'
                        })
                    ],
                    // inertia: true
                })
                .on('resizemove', function (event) {
                    const $target = $(event.target);

                    let x = parseFloat($target.attr('data-x')) || 0;
                    let y = parseFloat($target.attr('data-y')) || 0;

                    // Update the element's size and position
                    $target.css({
                        width: `${Number(event.rect.width)}px`,
                        height: `${Number(event.rect.height)}px`,
                        top: `${Number(y + event.deltaRect.top)}px`,
                        left: `${Number(x + event.deltaRect.left)}px`
                    });

                    // Update real size of draggable element
                    $target.find('.draggable-width').text(`${getFormattedMillimeters(event.rect.width, scale)} mm`);
                    $target.find('.draggable-height').text(`${getFormattedMillimeters(event.rect.height, scale)} mm`);

                    $target.attr('data-x', x + event.deltaRect.left);
                    $target.attr('data-y', y + event.deltaRect.top);
                    markProductLabelFormDirty();
                });
        }

        function isOverlapping(rect1, rect2) {
            return !(rect1.right < rect2.left ||
                rect1.left > rect2.right ||
                rect1.bottom < rect2.top ||
                rect1.top > rect2.bottom);
        }

        function checkOverlaps(elements) {
            for (let i = 0; i < elements.length; i++) {
                for (let j = i + 1; j < elements.length; j++) {
                    const block1Name = $(elements[i]).attr('data-name');
                    const block2Name = $(elements[j]).attr('data-name');
                    const rect1 = elements[i].getBoundingClientRect();
                    const rect2 = elements[j].getBoundingClientRect();

                    if (isOverlapping(rect1, rect2)) {
                        return false;
                    }
                }
            }

            return true;
        }

        function initTooltip() {
            if (typeof tippy === 'undefined') {
                return;
            }

            document.querySelectorAll('#product_label_wrapper .tooltip').forEach(function (tooltipElement) {
                if (tooltipElement._tippy) {
                    tooltipElement._tippy.destroy();
                }

                const title = tooltipElement.getAttribute('title');
                if (title) {
                    tooltipElement.setAttribute('data-original-title', title);
                    tooltipElement.removeAttribute('title');
                }

                tippy(tooltipElement, {
                    content(reference) {
                        return reference.getAttribute('data-original-title') || reference.getAttribute('aria-label') || '';
                    },
                    allowHTML: true,
                    interactive: true,
                    placement: tooltipElement.getAttribute('data-placement') || 'top',
                    arrow: true,
                    trigger: 'mouseenter focus'
                });
            });
        }

        function setDraggableActiveState(elements, isActive) {
            $(elements).each(function () {
                const draggableElement = $(this);

                draggableElement.toggleClass('active', isActive);
                if (isActive) {
                    draggableElement.addClass(productLabelDraggableActiveClasses);
                    return;
                }

                draggableElement.removeClass(productLabelDraggableActiveClasses);
            });
        }

        function applyDraggablePosition(element, position) {
            const draggableElement = $(element);
            const positionClasses = productLabelDraggablePositionClasses[position] || productLabelDraggablePositionClasses.center;
            const widthElement = draggableElement.find('.draggable-width');
            const heightElement = draggableElement.find('.draggable-height');

            draggableElement
                .removeClass(productLabelDraggablePositionResetClasses)
                .addClass(positionClasses.draggable);

            widthElement
                .removeClass(productLabelDraggableWidthPositionResetClasses)
                .addClass(positionClasses.width);

            heightElement
                .removeClass(productLabelDraggableHeightPositionResetClasses)
                .addClass(positionClasses.height);
        }

        function getCurrentProductLabelId() {
            return parseInt($('#product_label_form_wrapper #product_label_id', document).val(), 10) || 0;
        }

        function setActiveProductLabelListItem() {
            if (!currentProductLabelId || typeof setActiveListItem !== 'function') {
                return;
            }

            setActiveListItem('#product_label_list .product_label_list_item', currentProductLabelId, 'product_label_id');
        }

        function setProductLabelElementButtonState(element, state) {
            const button = $(element);

            button.removeClass(productLabelElementPrimaryStateClasses);
            button.removeClass(productLabelElementDangerStateClasses);

            if (state === 'danger') {
                button.addClass(productLabelElementDangerStateClasses);
                return;
            }

            button.addClass(productLabelElementPrimaryStateClasses);
        }

        function showProductLabelSaveSuccess() {
            if (typeof window.showButtonSuccessState === 'function') {
                window.showButtonSuccessState($('#product_label_save_btn', document));
            }
        }

        function markProductLabelFormDirty() {
            productLabelFormDirty = true;
        }

        function markProductLabelFormClean() {
            productLabelFormDirty = false;
        }

        function getCurrentLabelType() {
            const typeInput = $('#product_label_form_wrapper #product_label_type', document);
            return typeInput.length ? typeInput.val() : '';
        }

        function updateListHeader(type) {
            const titleNode = $('#product_label_list_title', document);
            const newBtn = $('#product_label_new_label_btn', document);
            if (titleNode.length) {
                const title = type === 'coupon' ? titleNode.attr('data-title-coupon') : titleNode.attr('data-title-product');
                if (title) {
                    titleNode.text(title);
                }
            }
            if (newBtn.length) {
                const labelName = type === 'coupon' ? newBtn.attr('data-title-coupon') : newBtn.attr('data-title-product');
                if (labelName) {
                    newBtn.contents().filter(function () {
                        return this.nodeType === 3;
                    }).remove();
                    newBtn.append(' Ny ' + labelName);
                }
            }
        }

        function confirmResetIfNeeded() {
            if (productLabelFormDirty) {
                return confirm('Dette vil tilbakestille skjemaet og lerretet. Fortsette?');
            }

            return true;
        }

        function switchLabelType(type) {
            ajaxLockActive = true;
            showPreloader();

            $.ajax({
                type: 'GET',
                url: ajaxPathProductLabel + '/0',
                data: {
                    type: type
                },
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_form_wrapper', document).replaceWith(data.html);
                updateListHeader(type);
                initColorPickers();
                initTooltip();
                markProductLabelFormClean();
                refreshList();
            }).error(function () {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke bytte etikettype', 'Lukk', 'error');
            }).always(function () {
                ajaxLockActive = false;
                hidePreloader();
            });
        }
    })();
});
